import React, { FC } from 'react';
import styled from '@emotion/styled';
import css from '@styled-system/css';

import { Box, Flex } from '../../../../layouts';
import { DrawerHeaderTitleProps } from './types';
import typeVariant from './variants/typeVariant';

export const StyledFlexTitle = styled(Flex)<DrawerHeaderTitleProps>(
  css({
    justifyContent: 'center',
    textAlign: 'center',
  })
);

const StyledTitle = styled(Box)<DrawerHeaderTitleProps>(typeVariant);

const DrawerHeaderTitle: FC<DrawerHeaderTitleProps> = ({
  children,
  type = 'block',
  ...props
}) => {
  return (
    <StyledFlexTitle {...props}>
      <StyledTitle type={type}>{children}</StyledTitle>
    </StyledFlexTitle>
  );
};

export default DrawerHeaderTitle;
